import React from 'react';
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { close } from 'ionicons/icons';

interface LeafEditorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const LeafEditorModal: React.FC<LeafEditorModalProps> = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{title}</IonTitle>
          <IonButton fill="clear" slot="end" onClick={onClose}>
            <IonIcon icon={close} />
          </IonButton>
        </IonToolbar>
      </IonHeader>
      
      <IonContent>
        <div style={{ padding: '1rem' }}>
          {children}
        </div>
      </IonContent>
    </IonModal>
  );
};

export default LeafEditorModal;
